module.exports = __webpack_public_path__ + "static/media/i1.67b43ecd.jpg";